import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { practiceShaperApiRef } from '../plugin';
import { GetSystemTypesRequest } from '@agilelab/plugin-wb-practice-shaper-common';
import { extractEntityTypeLabel } from '../utils';
import { EntityTypeLabel } from '../types';
import { useMemo } from 'react';

const CACHE_KEY = 'system-types';

export const useSystemTypes = (
  request?: GetSystemTypesRequest,
  options?: { enabled?: boolean },
) => {
  const practiceShaperApi = useApi(practiceShaperApiRef);

  const { data, isLoading, error } = useQuery({
    queryKey: [CACHE_KEY, request],
    queryFn: async () => {
      return (
        await practiceShaperApi.getSystemTypes({
          filter: request?.filter,
        })
      ).items;
    },
    enabled: options?.enabled ?? true,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    // refetches if the data is needed and 10 minutes have passed from the last fetch
    staleTime: 1000 * 60 * 10,
  });

  const kindLabels = useMemo(() => {
    const labels = new Map<string, EntityTypeLabel>();
    data?.forEach(item => {
      if (!item) return;
      const label = extractEntityTypeLabel(item, item.metadata.name);
      labels.set(item.metadata.name, label);
    });
    return labels;
  }, [data]);

  return {
    systemTypes: data,
    systemTypesLabelMap: kindLabels,
    loading: isLoading,
    error,
  };
};
